export default {
    props: ['titulo', 'info','simbulo'],
	template: `
		<div
			class="flex-1 max-w-[21.25rem] flex flex-col justify-center !h-[8rem] md2:flex-auto md2:max-w-full rounded-md p-16 border border-neutral-30 relative">
			<div class="flex items-start justify-between">
				<p class="text-xs font-medium tracking-widest text-neutral-70">
					{{titulo}}
				</p>

			</div>
			<p class="flex items-start gap-4 mt-10 text-2xl text-neutral-90">
				<span class="text-sm text-neutral-70">{{simbulo}}</span>
                {{info}}
			</p>

		</div>
	`,

}
